const pageIdConnect = new Map([
  ['jdxvehicle-ui-test1.jdl.cn', '/'],
  ['jdxvehicle-ui-beta.jdl.cn', ''],
  ['jdxvehicle-ui.jdl.cn', '_'],
]);
export const MenuClstag = new Map([
  [
    'MENU_deployManage_deployPlan',
    `app${pageIdConnect.get(
      window.location.host
    )}deployPlan|menu_click_deployPlan`,
  ],
]);
